<template lang="html">
  <div class="elevation-3">
    <v-tabs
      v-model="tabSelected"
      class="elevation-3"
      right
    > 
      <v-tab                
        v-for="item in filteredTabItems"
        :key="item.name"
      >
        <v-icon class="mr-3">
          {{ item.icon }}
        </v-icon>
        {{ item.name }}
        
        <v-avatar
          v-show="item.hide"
          color="red"
          size="7"
          class="mb-5"
        />
      </v-tab>
    </v-tabs>

    <v-tabs-items 
      v-model="tabSelected"
    >
      <div v-if="isTabOne">
        <task-table-assignee-task
          :employee-uid="employeeUid"
          :is-profile-tab="isProfileTab"
        />
      </div>
      <div v-if="isTabTwo">
        <task-table-owner-task
          :employee-uid="employeeUid"
          :is-profile-tab="isProfileTab"
        />
      </div>
      <div v-if="isTabThree">
        <task-table-viewer-task
          :employee-uid="employeeUid"
          :is-profile-tab="isProfileTab"
        />
      </div>
      <div v-if="isTabFour">
        <task-table-all-task :is-profile-tab="isProfileTab" />
      </div>
    </v-tabs-items>
  </div>
</template>

<script>
  export default {
    components: {
      TaskTableAssigneeTask: () => import('@/components/task/TableAssigneeTask'),
      TaskTableOwnerTask: () => import('@/components/task/TableOwnerTask'),
      TaskTableViewerTask: () => import('@/components/task/TableViewerTask'),
      TaskTableAllTask: () => import('@/components/task/TableAllTask'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isProfileTab: {
        type: Boolean,
      },
      isMyProfile: {
        type: Boolean,
      },
    },
    data () {
      return {
        tabSelected: 0,
        ownerCounter: false,
        assigneeCounter: false,
      }
    },
    computed: {
      filteredTabItems () {
        if (this.isMyProfile !== this.isProfileTab) {
          return [
            { id: 0, name: 'My Task', icon: 'fas fa-tasks', hide: this.assigneeCounter },
          ] 
        }

        let modifiedTab = [...[
          { id: 0, name: 'My Task', icon: 'fas fa-tasks', hide: this.assigneeCounter },
        ], 
        ]
        modifiedTab.splice(1, 0, { id: 1, name: 'Owner Task', icon: 'fas fa-tasks', hide: this.ownerCounter })
        modifiedTab.splice(2, 0, { id: 2, name: 'Viewer Task', icon: 'fas fa-tasks', hide: false })

        if (this.$hasPermissionTo(['view all tasks'])) {
          modifiedTab.splice(3, 0, { id: 3, name: 'All Task', icon: 'fas fa-tasks', hide: false })
        }

        return modifiedTab     
      },

      isTabOne () {
        return this.tabSelected === 0
      },
      isTabTwo () {
        return this.tabSelected === 1
      },
      isTabThree () {
        return this.tabSelected === 2
      },
      isTabFour () {
        return this.tabSelected === 3
      },
    },

    mounted () {       
      this.loadData()
      this.tabSelected = this.directTab(this.$route.params.id)
    },

    methods: {
      loadData () {
        Promise.all([
          this.$api.ownerTasks().pendingTaskCount(this.employeeUid),
          this.$api.ownerTasks().completedTaskCount(this.employeeUid),
          this.$api.assigneeTasks().pendingTaskCount(this.employeeUid),
        ])
          .then(([ownerPendingTaskCount, ownerCompletedTaskCount, assigneePendingTaskCount]) => {
            this.ownerCounter = ownerPendingTaskCount.data + ownerCompletedTaskCount.data
            this.assigneeCounter = assigneePendingTaskCount.data
          })
      },

      hideDot (item) {
        if (item.id === 1) {
          item.hide = false
        }
      },

      directTab (param) {
        if (param === 'owner') return 1
        if (param === 'viewer') return 2

        return 0
      },
    },
  }
</script>
